import React, { useRef, useState, useEffect } from "react";
import style from "../CSD/csd.module.scss";
import "../CSD/InstanceForms.scss";
import {
    I2cAccordionStepItem,
    I2cAccordionSteps,
    I2cButton,
    I2cSidebar,
    I2cCard,
    I2cTooltip,
    I2cIcon,
    I2cProgressBar,
} from "@webcomponents/i2cwebcomponents/dist/react";
import SecureHeader from "../../Components/SecureHeader/SecureHeader";
import GeographicRegionSelection from "../CholderCreditForm/GeographicRegionSelection/GeographicRegionSelection";
import SalesService from "../../Services/SalesService";
import { useNavigate, useParams, useSearchParams, useLocation } from "react-router-dom";
import UserManagmentService from "../../Services/UsermanagmentService";
import { useQuery } from "react-query";
import { OverlayLoader } from "../../Components/Loader/Loader";
import ConfirmaionModal from "../../Components/ConfirmationModal/ConfirmationModal";
import AlertMessage from "../../Components/SharedComponent/Alert/Alert";
import AppSelectionForProgram from "../CholderCreditForm/AppSelectionForProgram/AppSelectionForProgram";
import MultiCurrency from "./MultiCurrencyCardProducts/Multicurrency";
import CardProfileRegistration from "./CardProfileRegistration";
import GeneralInformation from "../CholderCreditForm/BrandInformation/GeneralInformation";
import WebAppPublicPageSpecifications from "../CholderCreditForm/BrandInformation/WebAppPublicPageSpecifications";
import MobileAppGraphicsSpecifications from "../CholderCreditForm/BrandInformation/MobileAppGraphicsSpecifications";
import CommonBrandingSpecifications from "../CholderCreditForm/BrandInformation/CommonBrandingSpecifications";
import CardEnrollment from "../CholderCreditForm/CardEnrollment/CardEnrollment";
import AdditionalAuthentications from "../CholderCreditForm/AdditionalAuthentications/AdditionalAuthentications"
import CardActivation from "../CholderCreditForm/AdditionalAuthentications/CardActivation";
import UserCreation from "../CholderCreditForm/AdditionalAuthentications/UserCreation";
import CardManagementFeature from "../CholderCreditForm/CardManagementFeature/CardManagementFeature";
import SignOff from "../CholderCreditForm/SignOff/SignOff";

const PrepaidProduct = () => {
    const [innerSteps, setInnerSteps] = useState([]);
    const accordionSteps = useRef(null);
    const [isMobileActive, setIsMobileActive] = useState(false);
    const [isMobileDevice, setIsMobileDevice] = useState(false);
    const nxtBtn = useRef(null);
    const resetBtn = useRef(null);
    const previousBtn = useRef(null);
    const progressStepsContent = useRef(null);
    const [open, setOpen] = useState(true);
    const { id: productId } = useParams();
    const location = useLocation(); // Access the location object
    const { formId } = location.state?.formId || {};
    const formIdFromSales = location.state?.formId;
    const [showConfirmatonModal, setShowConfirmatonModal] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const isReview = searchParams.get("review-screen") ?? false;
    const clientUser =
        localStorage.getItem("role") === "client" ??
        profileData?.role_name === "client";
    const navigate = useNavigate();
    const {
        data: user,
        refetch: refetchUserProfile,
        remove,
    } = useQuery("userProfile", () => UserManagmentService.getUserProfile(), {
        staleTime: 300000,
    });
    useEffect(() => {
        const checkIsMobile = () => {
            setIsMobileDevice(window.innerWidth <= 768);
        };
        checkIsMobile();
        window.addEventListener("resize", checkIsMobile);

        return () => {
            window.removeEventListener("resize", checkIsMobile);
        };
    }, []);
    const toggleMobileClass = () => {
        if (isMobileDevice) {
            setIsMobileActive(!isMobileActive);
        }
    };

    const profileData = user?.data?.data?.user;
    useEffect(() => {
        localStorage.setItem("role", profileData?.role_name ?? "");
    }, [user]);

    const addUpdateProducts = async (payload) => {
        try {
            const response = await SalesService.addUpdateProducts(payload);
            // Handle successful response

            return {
                isValid: response.data.status ?? true,
                id: response.data.product ?? productId,
            };
        } catch (error) {
            // Handle error
            console.error("Error:", error);
            return false;
        }
    };

    const queryKey = ["single-sale", productId];
    const validationQueryKey = ["single-sale-validations", productId];

    const fetchSaleProduct = async () => {
        if (productId) {
            try {
                const res = await SalesService.fetchSaleProduct(productId);
                const productData = res.data.data[0]?.product_data;

                if (productData) {
                    try {
                        const data = JSON.parse(productData);
                        setAddFormData({ ...data });
                    } catch (jsonError) {
                        console.error("Failed to parse JSON:", jsonError, "Product data:", productData);
                    }
                } else {
                    console.warn("No product data found for product ID:", productId);
                }

                return res?.data?.data[0];
            } catch (error) {
                console.error("Error fetching sale product:", error);
            }
        } else {
            console.warn("Product ID is not defined");
        }
        return null;
    };

    const fetchSingleSaleValidStates = async () => {
        const res = await SalesService.fetchProductValidStates(productId);
        return res.data.data[0]?.validation_states;
    };
    // Fetch sessions data using React Query hook
    const {
        data: singleForm,
        isLoading,
        isFetching,
        refetch,
    } = useQuery(queryKey, fetchSaleProduct, {
        enabled: !!productId, // Only fetch if productId is present,
        staleTime: Infinity,
    });

    const {
        data: tempSingleFormValidStates,
        isLoading: isValidStatesLoading,
        isFetching: isValidStatesFetching,
        refetch: refetchFormsValidStates,
    } = useQuery(validationQueryKey, fetchSingleSaleValidStates, {
        enabled: !!productId, // Only fetch if productId is present,
        staleTime: Infinity,
    });
    useEffect(() => {
        refetch();
    }, []);

    const signatureDataJson = JSON.parse(singleForm?.signature ?? "{}");
    const formDataJson = JSON.parse(singleForm?.product_data ?? "{}");
    const appSelectionForProgram = formDataJson[1]?.["1_0"]?.app_selection_for_program || [];
    const isWebSelected = appSelectionForProgram.includes("C-Holder Website");
    const isMobileSelected = appSelectionForProgram.includes("Android App") || appSelectionForProgram.includes("iOS App");
    const singleFormValidStates = JSON.parse(tempSingleFormValidStates ?? "[]") ?? [];

    const setActiveStep = (main, inner) => {
        if (accordionSteps.current.getActiveTabs()) {
            accordionSteps.current.removeActive();
        }
        const allItems = accordionSteps.current.getItems();
        if ([3, 5].includes(main)) {
            const itemToBeActive = allItems[main].getChildrenItems()[inner];
            const itemToBeActivePath =
                accordionSteps.current.getPathForItem(itemToBeActive);
            accordionSteps.current.markStepInprogress(
                itemToBeActive,
                itemToBeActivePath,
            );
            allItems[main].open = true;
        } else {
            accordionSteps.current.markStepInprogress(allItems[main], [main]);
        }

        if ([3, 5].includes(main))
            handleProgressStep(`step-${main}-${inner}`);
        else handleProgressStep(`step-${main}`);
        setActiveMainStep(main);
        setActiveInnerStep(inner);
    };

    const handleButtonClick = () => {
        navigate(".", { replace: true });
    };

    useEffect(() => {
        if (isReview) {
            setTimeout(() => {
                setActiveStep(9, 0);
            }, 1000);
            setTimeout(() => {
                handleButtonClick();
            }, 3000);
        }
    }, [isReview]);

    const [activeMainStep, setActiveMainStep] = useState(0);
    const [activeInnerStep, setActiveInnerStep] = useState(0);
    const [activeStepper, setActiveStepper] = useState(0);
    const isValidationError = searchParams.get("validation-error") ?? false;

    const [addFormData, setAddFormData] = useState({
        0: {
            "0_0": {
                geographical_regions_selection: "",
                geographical_regions_details_others: "",
            },
        },
        1: {
            "1_0": {
                app_selection_for_program: "",
            },
        },
        2: {
            "2_0": {
                multicurrency_card_offer_multicurrency: "Yes",
                multicurrency_card_main_currency: "",
                multicurrency_card_supported_currency: []
            },
        },
        3: {
            "3_0": {
                brand_info_general_info_client_name: "",
                brand_info_general_info_brand_name: "",
                brand_info_general_info_responsible_for_app_publish: "",
                brand_info_general_info_card_network: "",
                brand_info_general_info_card_network_other: "",
                brand_info_general_info_brand_color: "Brand color scheme",
                brand_info_general_info_brand_color_custom_primary: "",
                brand_info_general_info_brand_color_custom_secondary: "",
                brand_info_general_info_brand_color_custom_neutral: "",
                brand_info_general_info_url_type_enrollment_screen: "i2c standard URL",
                brand_info_general_info_url_type_enrollment_screen_custom: "",
                brand_info_general_info_language: "",
                brand_info_general_info_language_other: "",
                brand_info_general_info_target_launch_date: "",
                brand_info_general_info_target_launch_date_mobile_app: "",
                brand_info_general_info_target_launch_date_web_app: "",
                brand_info_general_info_brand_logo_file: ""
            },
            "3_1": {
                brand_info_common_brand_contact_us_feature_type: "Use i2c Standard Feature",
                brand_info_common_brand_contact_us_i2c_standard_email: "",
                brand_info_common_brand_contact_us_i2c_standard_customer_call_phone: "",
                brand_info_common_brand_contact_us_i2c_standard_customer_call_phone_country: "",
                brand_info_common_brand_contact_us_i2c_standard_cardholder_enrollment_phone: "",
                brand_info_common_brand_contact_us_i2c_standard_cardholder_enrollment_phone_country: "",
                brand_info_common_brand_contact_us_i2c_standard_working_hours: "",
                brand_info_common_brand_contact_us_i2c_standard_head_office_address: "",
                brand_info_common_brand_contact_us_i2c_standard_postal_address: "",
                brand_info_common_brand_contact_us_i2c_standard_facebook_link: "",
                brand_info_common_brand_contact_us_i2c_standard_instagram_link: "",
                brand_info_common_brand_contact_us_i2c_standard_twitter_link: "",
                brand_info_common_brand_contact_us_i2c_standard_youtube_link: "",
                brand_info_common_brand_contact_us_i2c_standard_linkedin_link: "",
                brand_info_common_brand_contact_us_custom: [
                    {
                        page_name: "",
                        page_link: "",
                    },
                ],
                brand_info_common_brand_faqs_type: "Use Customized Content",
                brand_info_common_brand_faqs_content_file: [],
                brand_info_common_brand_faqs_external_link: "",
                brand_info_common_brand_terms_and_condition_type: "Use Customized Content",
                brand_info_common_brand_terms_and_condition_content_file: [],
                brand_info_common_brand_terms_and_condition_content_link: "",
                brand_info_common_brand_privacy_policy_type: "Use Customized Content",
                brand_info_common_brand_privacy_policy_content_file: [],
                brand_info_common_brand_privacy_policy_content_link: "",
                brand_info_common_brand_security_awareness_type: "Use Customized Content",
                brand_info_common_brand_security_awareness_content_file: [],
                brand_info_common_brand_security_awareness_content_link: "",
                brand_info_common_brand_feature: [
                    {
                        name: "",
                        description: "",
                        attachment_file: ""
                    }
                ],
                brand_info_common_brand_atm_locator: "Yes",
                brand_info_common_brand_atm_locator_content_file: ""

            },
            "3_2": {
                brand_info_web_app_add_program_logo: "Yes",
                brand_info_web_app_program_logo_file: "",
                brand_info_web_app_add_link_to_public_pages: "Yes",
                // brand_info_web_app_links_to_public_pages: [],
                brand_info_web_app_add_link_to_self_service_enrollment: "Yes",
                brand_info_web_app_add_card_activation_feature: "",
                brand_info_web_app_main_banner_file: "",
                brand_info_web_app_heading_and_text: "",
                brand_info_web_app_add_video_link: "Yes",
                brand_info_web_app_video_url: "",
                brand_info_web_app_offer_card_products_for_enrollment: [],
                brand_info_web_app_content_for_card_products: "",
                brand_info_web_app_responsible_for_card_product_images: "i2c to provide images",
                brand_info_web_app_card_product_images_file: [],
                brand_info_web_app_content_for_card_products_features: "",
                brand_info_web_app_responsible_for_card_products_features_images: "i2c to provide images",
                brand_info_web_app_card_products_features_images_file: [],
                brand_info_web_info_section_vi_add_section_to_landing_page: "Yes",
                brand_info_web_info_section_vi_icon_textual_content_images_file: [],
                brand_info_web_info_add_image_of_mobile_app_section: "Yes",
                brand_info_web_info_add_links_for_app: [],
                brand_info_web_info_mobile_app_images_file: [],
                brand_info_web_info_footer_public_pages_links: [],
                brand_info_web_info_footer_public_pages_content: "",
                brand_info_web_app_public_pages: [{
                    page_name: "",
                    page_link: "",
                    isDefault: false
                },]
            },
            "3_3": {
                brand_info_mob_app_icon_file: "",
                brand_info_mob_app_splash_screen_file: "",
                brand_info_mob_app_card_design_file: "",
                brand_info_mob_app_textual_content: "",
                brand_info_mob_app_art_background_image_file: "",
                brand_info_mob_app_additional_textual_content_file: "",
                brand_info_mob_app_sign_up_option: "Yes",
                brand_info_mob_app_nav_color_scheme: "Default color scheme",
                brand_info_mob_app_nav_color_scheme_field: "",
                brand_info_mob_app_nav_color_scheme_logo: "",
                brand_info_mob_app_login_color_scheme_code: [''],
                brand_info_mob_app_login_background_file: "",
                brand_info_mob_app_public_menus_icons_type: "Custom Menus & Icons",
                brand_info_mob_app_public_menus_custom: [],
                brand_info_mob_app_ios_icon_file: "",
                brand_info_mob_app_ios_app_name: "",
                brand_info_mob_app_ios_description_for_app_store: "",
                brand_info_mob_app_ios_keywords: "",
                brand_info_mob_app_ios_support_url: "",
                brand_info_mob_app_ios_module_features_file: [],
                brand_info_mob_app_android_icon_file: "",
                brand_info_mob_app_android_app_name: "",
                brand_info_mob_app_android_description_for_app_store: "",
                brand_info_mob_app_android_keywords: "",
                brand_info_mob_app_android_support_url: "",
                brand_info_mob_app_android_module_features_file: [],
            },
        },
        4: {
            "4_0": {
                card_enrollment_manage_enrollment_type: "Manage enrollment outside i2c platform",
                card_enrollment_link_enrollment_platform_to_i2c: "Yes",
                card_enrollment_card_enrollment_url_type: "Custom URL",
                card_enrollment_card_enrollment_url: "",
                card_enrollment_url_platform: [],
                card_enrollment_card_account_type: "",
                card_enrollment_category_consumer_link_platform_to_i2c: "No",
                card_enrollment_category_consumer_title_for_enrollment_screen: "",
                card_enrollment_category_consumer_description_for_enrollment_screen: "",

                card_enrollment_category_business_link_platform_to_i2c: "No",
                card_enrollment_category_business_title_for_enrollment_screen: "",
                card_enrollment_category_business_description_for_enrollment_screen: "",
                card_enrollment_category_corporate_link_platform_to_i2c: "No",
                card_enrollment_category_corporate_title_for_enrollment_screen: "",
                card_enrollment_category_corporate_description_for_enrollment_screen: "",
                card_enrollment_card_product_groups: [{
                    images_file: [],
                    count: "",
                    title: "",
                    description: "",
                }],

                card_enrollment_create_user_during_enrollment: "Yes",
                card_enrollment_customer_email_as_user_id: "No",
                card_enrollment_show_email_id_on_screen: "No",

                card_enrollment_fields_for_corporate_login_info: [],
                card_enrollment_fields_for_corporate_account_info: [],
                card_enrollment_fields_for_corporate_additional_card_info: [],
                card_enrollment_fields_for_corporate_documentation: [],
                card_enrollment_fields_for_corporate_employee_info: [],
                card_enrollment_fields_for_corporate_business_owner_info: [],
                card_enrollment_fields_for_corporate_business_info: [],

                card_enrollment_fields_for_business_login_info: [],
                card_enrollment_fields_for_business_account_info: [],
                card_enrollment_fields_for_business_additional_card_info: [],
                card_enrollment_fields_for_business_documentation: [],
                card_enrollment_fields_for_business_employee_info: [],
                card_enrollment_fields_for_business_business_owner_info: [],
                card_enrollment_fields_for_business_business_info: [],

                card_enrollment_fields_for_consumer_source_of_income_info: [],
                card_enrollment_fields_for_consumer_personal_info: [],
                card_enrollment_fields_for_consumer_login_info: [],
                card_enrollment_fields_for_consumer_identification_info: [],
                card_enrollment_fields_for_consumer_documentary_proof_info: [],

                card_enrollment_agreement_for_customer_acceptance: "",
                card_enrollment_agreement_type_for_common_toggle: [],
                card_enrollment_agreement_type: "Use Customized Content",
                card_enrollment_agreement_external_content_url: "",
                card_enrollment_agreement_customized_content_file: [],
                card_enrollment_funding_option: [],
                card_enrollment_funding_option_payment_gateway: "",
                card_enrollment_funding_option_payment_gateway_other: "",
                card_enrollment_shipping_method: []
            },
        },
        5: {
            "5_0": {
                additional_auth_methods: "",
                additional_auth_methods_other: "",
                additional_auth_otp_channels: "",
                additional_auth_methods_secondary: "",
                additional_auth_methods_secondary_other: "",
                additional_auth_feature_additional_auth: []
            },
            "5_1": {
                additional_allow_card_activation_using_app: "Yes",
                additional_validations_for_card_activation: [],
                additional_set_pin_after_card_activation: "",
                additional_card_activation_method: ""
            },
            "5_2": {
                additional_customer_email_as_user_id: "No",
                additional_email_id_on_screen: "Yes",
                additional_info_for_user_creation: [],
                additional_authentication_channel_for_user_creation: "OTP",
                additional_authentication_channel_for_user_creation_OTP: "",
                additional_authentication_channel_for_user_creation_Profile_Verification: [],
                additional_support_additional_authentications: "No",
                additional_support_additional_authentications_details: "",
                additional_provide_agreement_for_customer_acceptance: "Yes",
                additional_agreement_type_for_toggle_control: "Accept Electronic Communication",
                additional_agreement_content_type: "Use Customized Content",
                additional_agreement_content_type_external_url: "",
            },
            "5_3": {
                additional_card_profile_registration: [],
            }

        },
        6: {
            "6_0": {
                card_management_feature_my_account_feature_required_for: [],
                card_management_feature_my_account_feature_required_for_custom: "",
                card_management_feature_card_services_feature_app_enable: "Yes",
                card_management_feature_card_services_feature_required_for: [],
                card_management_feature_card_services_feature_app_enable_custom: "",
                card_management_feature_card_services_card_activation_after_login: "Yes",
                card_management_feature_card_services_info_for_validation: [],
                card_management_feature_share_fund_feature_required_for: [],
                card_management_feature_share_fund_feature_app_enable: "Yes",
                card_management_feature_share_fund_feature_required_for_custom: "",
                card_management_feature_share_fund_enable_friend_and_family: "Yes",
                card_management_feature_share_fund_enable_schedule_transfer: "Yes",
                card_management_feature_share_fund_schedule_transfer_custom: "",
                card_management_feature_share_fund_enable_wallet_transfer: "Yes",
                card_management_feature_manage_bank_accounts_app_enable: "Yes",
                card_management_feature_manage_bank_accounts_custom: "",
                card_management_feature_manage_bank_accounts_feature_required_for: [],
                card_management_feature_manage_bank_accounts_primary_method: [],
                card_management_feature_manage_bank_accounts_primary_method_other: "",
                card_management_feature_manage_bank_accounts_enable_micropayment_method: "Yes",
                card_management_feature_rewards_and_cashback_feature_app_enable: "Yes",
                card_management_feature_rewards_and_cashback_feature_required_for: [],
                card_management_feature_rewards_and_cashback_rewards_type: "",
                card_management_feature_rewards_and_cashback_manual_redeem: "Yes",
                card_management_feature_dispute_form_feature_app_enable: "Yes",
                card_management_feature_dispute_form_dispute_options: [],
                card_management_feature_dispute_form_feature_required_for: [],
                card_management_feature_dispute_form_type: "Customized Form",
                card_management_feature_dispute_form_custom_form_file: "",
                card_management_feature_account_notification_feature_required_for: [],
                card_management_feature_account_notification_feature_enable_alert: "Yes",
                card_management_feature_manage_pin_feature_app_enable: "Yes",
                card_management_feature_manage_pin_feature_required_for: [],
                card_management_feature_manage_pin_info_verification_for_change_pin: [],
                card_management_feature_manage_pin_feature_app_enable_custom: "",
                card_management_feature_manage_profile_feature_required_for: [],
                card_management_feature_manage_profile_info_verification_for_pin_change: [],
                card_management_feature_manage_profile_enable_captcha: "Yes",
                card_management_feature_spending_controls_feature_required_for: [],
                card_management_feature_bank_accounts_feature_app_enable: "Yes",
                card_management_feature_bank_accounts_feature_required_for: [],
                card_management_feature_bank_accounts_feature_app_enable_custom: "",
                card_management_feature_bank_accounts_primary_methods_for_account_setup: "",
                card_management_feature_bank_accounts_fallback_micropayment_method: "Yes",
                card_management_feature_bill_payments_feature_app_enable: "Yes",
                card_management_feature_bill_payments_feature_required_for: [],
                card_management_feature_bill_payments_feature_app_enable_custom: "",
                card_management_feature_wallet_provision_feature_app_enable: "Yes",
                card_management_feature_wallet_provision_digital_wallet_types: [],
                card_management_feature_wallet_provision_payment_networks: [],
                card_management_feature_order_supplementary_card_app_enable: "Yes",
                card_management_feature_order_supplementary_card_feature_required_for: [],
                card_management_feature_order_supplementary_card_verify_to_change_pin: [],
                card_management_feature_manage_access_code_feature_app_enable: "Yes",
                card_management_feature_manage_access_code_feature_app_enable_custom: "",
                card_management_feature_manage_access_code_feature_required_for: [],
                card_management_feature_manage_access_code_info_verification_for_code_access: [],
                card_management_feature_manage_access_code_verify_to_send_access_code: [],
                card_management_feature_message_center_feature_app_enable: "Yes",
                card_management_feature_message_center_feature_required_for: [],
                card_management_feature_message_center_feature_app_enable_custom: "",
                card_management_feature_direct_deposit_feature_app_enable: "Yes",
                card_management_feature_direct_deposite_feature_required_for: [],
                card_management_feature_direct_deposit_customize_for: "Yes",
                card_management_feature_direct_deposite_customized_file_name: "",
                card_management_feature_mRDC_feature_support: "Yes",
                card_management_feature_mRDC_feature_required_for: [],
                card_management_feature_manage_wallet_feature_support: "Yes",
                card_management_feature_manage_wallet_feature_required_for: [],
                card_management_feature_load_funds_feature_support: "Yes",
                card_management_feature_load_funds_feature_required_for: [],
                card_management_feature_load_funds_opt_for_card_account: [],
                card_management_feature_load_funds_payment_gateway: [],
                card_management_feature_load_funds_channel: "",
                card_management_feature_all_cashout_feature_support: "Yes",
                card_management_feature_all_cashout_feature_required_for: [],
                card_management_feature_overdraft_feature_support: "Yes",
                card_management_feature_overdraft_feature_required_for: [],
                card_management_feature_saving_purse_feature_support: "Yes",
                card_management_feature_saving_purse_required_for: [],
                card_management_feature_additional_service: "",
                card_management_feature_transfer_funds_app_enable: "Yes",
                card_management_feature_transfer_funds_feature_required_for: [],
                card_management_feature_transfer_funds_features: [],
                card_management_feature_spending_controls_options: [],
            }
        },

    });
    const activeStep = activeMainStep + "_" + activeInnerStep;
    const [formValidStates, setFormValidStates] = useState({
        "0_0": false,
        "1_0": false,
        "2_0": false,
        "3_0": false,
        "3_1": false,
        "3_2": false,
        "3_3": false,
        "4_0": false,
        "5_0": false,
        "5_1": false,
        "5_2": false,
        "5_3": false,
        "6_0": false,
        "7_0": false,
    });

    const handleSetFormValidState = (key, value) => {
        setFormValidStates({
            ...formValidStates,
            [key]: value,
        });
    };

    function updateKeysToObject(obj, keys) {
        // Create a copy of the original object
        const updatedObject = { ...obj };
        // Loop through the keys array and set the corresponding values in the object to true
        keys.forEach((key) => {
            if (updatedObject.hasOwnProperty(key)) {
                updatedObject[key] = true;
            }
        });

        return updatedObject;
    }

    useEffect(() => {
        if (!isValidStatesFetching) {
            const formValidStatesTemp = updateKeysToObject(
                formValidStates,
                singleFormValidStates,
            );

            setFormValidStates(formValidStatesTemp);
        }
    }, [isValidStatesFetching]);

    const css = `
 
  #progress-steps-content {
      margin-block: var(--i2c-spacing-2-5);
      @media (max-width: 768px){
        margin-block: 0;
      }
  }
  #progress-steps-content > div {
      display: none;
  }
  #progress-steps-content > div.active {
      display: block;
  }
  i2c-accordion-step-item i2c-accordion-step-item  .step-icon{
    display: none
    }
`;

    const [signatureData, setSignatureData] = useState({
        sign_off_client_name: "",
        sign_off_title: "",
        sign_off_date: "",
        sign_off_signature_type: "",
        sign_off_signature: "",
    });

    useEffect(() => {
        if (!isFetching && Object.keys(signatureDataJson ?? {})?.length) {
            setSignatureData({ ...signatureDataJson });
        }
    }, [isFetching]);

    useEffect(() => {
        if (isValidationError) {
            setTimeout(() => {
                handleButtonClick();
            }, 3000);
        }
    }, [isValidationError]);

    const stepArray2PV = [
        {
            id: "step-02PV",
            step_id: "step-0",
            title: "Geographical Region(s) Selection",
            innerSteps: [],
            description: (
                <GeographicRegionSelection
                    type="prepaid"
                    setAddFormData={setAddFormData}
                    addFormData={addFormData}
                    setFormValidStates={handleSetFormValidState}
                    formDataJson={formDataJson}
                    isFetching={isFetching}
                />
            ),
        },
        {
            id: "step-12PV",
            step_id: "step-1",
            title: "App Selection for Program",
            innerSteps: [],
            description: (
                <AppSelectionForProgram
                    type="prepaid"
                    setAddFormData={setAddFormData}
                    addFormData={addFormData}
                    setFormValidStates={handleSetFormValidState}
                    formDataJson={formDataJson}
                    isFetching={isFetching}
                />
            ),
        },
        {
            id: "step-22PV",
            step_id: "step-2",
            title: "Multi-Currency Card Products",
            innerSteps: [],
            description: (
                <MultiCurrency
                    type="prepaid"
                    setAddFormData={setAddFormData}
                    addFormData={addFormData}
                    setFormValidStates={handleSetFormValidState}
                    formDataJson={formDataJson}
                    isFetching={isFetching}
                />
            ),
        },
        {
            id: "step-32PV",
            step_id: "step-3",
            title: "Brand Information",
            description: "",
            innerSteps:
                [
                    {
                        id: "inner-step-3-0",
                        title: "General Information",
                        description: (
                            <GeneralInformation
                                type="prepaid"
                                setAddFormData={setAddFormData}
                                addFormData={addFormData}
                                setFormValidStates={handleSetFormValidState}
                                formDataJson={formDataJson}
                                isFetching={isFetching}
                            />
                        ),
                        step_id: "step-3-0",
                        labelText: "",
                        tooltip: "",
                    },
                    {
                        id: "inner-step-3-1",
                        title: "Common Branding Specifications",
                        description: (
                            <CommonBrandingSpecifications
                                type="prepaid"
                                setAddFormData={setAddFormData}
                                addFormData={addFormData}
                                setFormValidStates={handleSetFormValidState}
                                formDataJson={formDataJson}
                                isFetching={isFetching}
                            />
                        ),
                        step_id: "step-3-1",
                        labelText: "",
                        tooltip: "",
                    },
                    {
                        id: "inner-step-3-2",
                        title: "Web App Public Page Specifications",
                        description: (
                            <WebAppPublicPageSpecifications
                                type="prepaid"
                                setAddFormData={setAddFormData}
                                addFormData={addFormData}
                                setFormValidStates={handleSetFormValidState}
                                formDataJson={formDataJson}
                                isFetching={isFetching}
                            />
                        ),
                        step_id: "step-3-2",
                        labelText: "",
                        tooltip: "",
                    },
                    {
                        id: "inner-step-3-3",
                        title: "Mobile App Graphics Specifications",
                        description: (
                            <MobileAppGraphicsSpecifications
                                type="prepaid"
                                setAddFormData={setAddFormData}
                                addFormData={addFormData}
                                setFormValidStates={handleSetFormValidState}
                                formDataJson={formDataJson}
                                isFetching={isFetching}
                            />
                        ),
                        step_id: "step-3-3",
                        labelText: "",
                        tooltip: "",
                    },
                ],
        },
        {
            step_id: "step-4",
            id: "step-42PV",
            title: "Card Enrollment",
            innerSteps: [],
            description: (
                <CardEnrollment
                    type="prepaid"
                    setAddFormData={setAddFormData}
                    addFormData={addFormData}
                    setFormValidStates={handleSetFormValidState}
                    formDataJson={formDataJson}
                    isFetching={isFetching}
                />
            ),
        },
        {
            id: "step-52PV",
            step_id: "step-5",
            title: "Additional Authentication, Card Activation, and User Creation",
            description: "",
            innerSteps: [
                {
                    id: "inner-step-5-0",
                    title: "Additional Authentication",
                    description: (
                        <AdditionalAuthentications
                            type="prepaid"
                            setAddFormData={setAddFormData}
                            addFormData={addFormData}
                            setFormValidStates={handleSetFormValidState}
                            formDataJson={formDataJson}
                            isFetching={isFetching}
                        />
                    ),
                    step_id: "step-5-0",
                    labelText: "",
                    tooltip: "",
                },
                {
                    id: "inner-step-5-1",
                    title: "Card Activation",
                    description: (
                        <CardActivation
                            type="prepaid"
                            setAddFormData={setAddFormData}
                            addFormData={addFormData}
                            setFormValidStates={handleSetFormValidState}
                            formDataJson={formDataJson}
                            isFetching={isFetching}
                        />
                    ),
                    step_id: "step-5-1",
                    labelText: "",
                    tooltip: "",
                },
                {
                    id: "inner-step-5-2",
                    title: "User Creation",
                    description: (
                        <UserCreation
                            type="prepaid"
                            setAddFormData={setAddFormData}
                            addFormData={addFormData}
                            setFormValidStates={handleSetFormValidState}
                            formDataJson={formDataJson}
                            isFetching={isFetching}
                        />
                    ),
                    step_id: "step-5-2",
                    labelText: "",
                    tooltip: "",
                },
                {
                    id: "inner-step-5-3",
                    title: "Card Profile Registration",
                    description: (
                        <CardProfileRegistration
                            type="prepaid"
                            setAddFormData={setAddFormData}
                            addFormData={addFormData}
                            setFormValidStates={handleSetFormValidState}
                            formDataJson={formDataJson}
                            isFetching={isFetching}
                        />
                    ),
                    step_id: "step-5-3",
                    labelText: "",
                    tooltip: "",
                },
            ],
        },
        {
            step_id: "step-6",
            id: "step-62PV",
            title: "Card Management Features",
            description: (
                <CardManagementFeature
                    type="prepaid"
                    setAddFormData={setAddFormData}
                    addFormData={addFormData}
                    setFormValidStates={handleSetFormValidState}
                    formDataJson={formDataJson}
                    isFetching={isFetching}
                />
            ),

        },
        {
            id: "inner-step-7",
            title: "Sign Off",
            description: (
                <SignOff
                    setAddFormData={setSignatureData}
                    addFormData={signatureData}
                    setFormValidStates={handleSetFormValidState}
                    formDataJson={signatureDataJson}
                    isFetching={isFetching}
                />
            ),
            step_id: "step-7",
            labelText: "",
            tooltip: "",
        }
    ];

    if (clientUser) {
        const step92PV = stepArray2PV.find((step) => step.id === "step-92PV");
        if (
            stepArray2PV.find((step) => step.id === "step-92PV") &&
            !step92PV.innerSteps.find((step) => step.id === "inner-step-9-1")
        ) {
            // Ensure the step does not already exist before appending
            step92PV.innerSteps.push({
                id: "inner-step-7-0",
                title: "Sign Off",
                description: (
                    <SignOff
                        setAddFormData={setSignatureData}
                        addFormData={signatureData}
                        setFormValidStates={handleSetFormValidState}
                        formDataJson={signatureDataJson}
                        isFetching={isFetching}
                    />
                ),
                step_id: "step-7",
                labelText: "",
                tooltip: "",
            });
        }
    }

    useEffect(() => {
        if (clientUser && singleForm?.form_status_id !== 4) {
            setFormValidStates((prevState) => ({
                ...prevState,
                "7_0": false,
            }));
            const updatedAddFormData = Object.keys({ ...formDataJson }).length
                ? { ...formDataJson }
                : { ...addFormData };
            updatedAddFormData[7]["7_0"] = {};

            setAddFormData(updatedAddFormData);
        }
    }, [clientUser]);

    const handleNext = async () => {
        // Ensure 6_0 key exists in addFormData state
        const updatedAddFormData = { ...addFormData };
        if (!updatedAddFormData[7]) {
            updatedAddFormData[7] = {};
        }
        updatedAddFormData[7]["7_0"] = {};

        // Prepare the payload for the API call
        const formDataPayload = {
            product_type: 1,
            form_id: formIdFromSales,
            product_name: "Test Form",
            product_data: updatedAddFormData,
            outer_index: activeMainStep,
            inner_index: activeMainStep + "_" + activeInnerStep,
        };

        if (productId) {
            formDataPayload["id"] = productId;
            formDataPayload.signature = signatureData;
        }

        // Call the API to save the data
        const res = await addUpdateProducts(formDataPayload);
        if (res.isValid) {
            // Handle navigation and form state updates
            refetchFormsValidStates();
            const activeStep = stepArray2PV[activeMainStep];
            const innerSteps = activeStep.innerSteps;
            if (innerSteps && activeInnerStep < innerSteps.length - 1) {
                setActiveStep(activeMainStep, activeInnerStep + 1);
            } else if (activeMainStep < stepArray2PV.length - 1) {
                setActiveStep(activeMainStep + 1, 0);
            }
            navigate(`/cholder/debit/edit/${res.id}`);
        } else {
            searchParams.set("validation-error", true);
            setSearchParams(searchParams);
        }
    };
    function handlePrevious() {
        accordionSteps.current.setPreviousStep();
    }

    function handleReset() {
        setShowConfirmatonModal(true);
    }
    function handleResetPopup() {
        setShowConfirmatonModal(true);
    }
    function handleProgressStep(event) {
        let activeStep;
        if (!event.length) {
            activeStep = event.detail.element.getAttribute("step-id");
        } else activeStep = event;
        const stepContent = progressStepsContent.current.querySelector(
            `#${activeStep}`,
        );

        const allContent = progressStepsContent.current.querySelectorAll("div");
        allContent.forEach((div) => {
            div.classList.remove("active");
        });
        stepContent.classList.add("active");
    }

    // useEffect(() => {
    //   if (progressStepper2PV) {
    //     progressStepper2PV.steps = steps;
    //   }
    // }, [progressStepper2PV, steps]);

    const countValidSteps = (formValidatonConditions, keysArray) => {
        let totalCount = 0;

        formValidatonConditions.forEach((condition) => {
            const matchingKeys = keysArray.filter((key) =>
                key.startsWith(condition.prefix),
            );
            if (matchingKeys.length === condition.count) totalCount += 1;
        });

        return totalCount;
    };

    function checkParentStepValidation(array, prefix, count) {
        // Filter the array to get only the strings that start with the specified prefix
        const filteredStrings = array.filter((str) => str.startsWith(prefix));

        // Check if the count of filtered strings matches the expected count
        return filteredStrings.length === count;
    }

    const formValidatonConditions = [
        { prefix: "0_", count: 1 },
        { prefix: "1_", count: 1 },
        { prefix: "2_", count: 1 },
        { prefix: "3_", count: 4 },
        { prefix: "4_", count: 1 },
        { prefix: "5_", count: 4 },
        { prefix: "6_", count: 1 },
        { prefix: "7_", count: 1 },

    ];

    const isMainStepCompleted = (stepNumber) => {
        const innerSteps = Object.keys(formValidStates).filter((key) =>
            key.startsWith(stepNumber + "_"),
        );
        return innerSteps.every((key) => formValidStates[key]);
    };

    const getTotalValidSteps = () => {
        // Calculate completion status of each main step
        let count = 0;
        for (let i = 0; i <= 6; i++) {
            if (isMainStepCompleted(i)) count += 1;
        }
        return count;
    };
    const isFormSubmittable = Object.values(formValidStates).every(
        (value) => value === true,
    );
    const sidebarComponent = (
        <I2cSidebar
            // auto-hide
            hasBottomNav
            open={open}
            id="I2cSidebar3"
            position="absolute"
            contained
            noEscapeClose
            className={`${isMobileActive ? "activeMobileClass " : ""}i2c-prepaid-instance-sidebar`}
        // className="i2c-prepaid-instance-sidebar"
        >
            <div className="bg_contain" slot="filter">
                <h3>Cholder Web and <br /> Mobile (Prepaid)</h3>
                <div className="progress-holder" onClick={toggleMobileClass}>
                    <I2cProgressBar
                        value={
                            countValidSteps(formValidatonConditions, singleFormValidStates) *
                            14.28
                        }
                        variant="success"
                        style={{ "--height": "var(--i2c-spacing-2)" }}
                    ></I2cProgressBar>
                    <span className="custom-label">
                        {countValidSteps(formValidatonConditions, singleFormValidStates)}
                        /7
                    </span>
                </div>
            </div>
            <div slot="content">
                <ConfirmaionModal
                    open={showConfirmatonModal}
                    parentClass="height-fix"
                    setOpen={() => setShowConfirmatonModal(false)}
                    title={"Unsaved Changes?"}
                    headerArt={"cs-linear-alert-circle"}
                    message={"Are you sure you want to discard these changes?"}
                    variant="warning"
                    layout={"layoutCenter"}
                    cancelButtonText={"Skip"}
                    confirmButtonText={"Yes"}
                    confirmBtnVariant={"primary"}
                    handleConfirmation={() => navigate(-1)}
                />
                <div className="card-basic">
                    <I2cCard className="card-basic">
                        <I2cAccordionSteps
                            className={style.accordReset}
                            ref={accordionSteps}
                            onI2cUpdatedProgress={(event) => {
                                handleButtonClick();
                                const path = event.detail.path ?? [];
                                setActiveMainStep(path[0]);
                                setActiveInnerStep(path[1] ?? 0);
                                handleProgressStep(event);
                                setTimeout(() => {
                                    const elements = document.getElementsByClassName("active");
                                    if (elements?.length)
                                        elements[0]?.scrollIntoView({ behavior: "smooth" });
                                }, 300);
                            }}
                            type="parentLine"
                            variant="borderless"
                            size="md"
                        >
                            {stepArray2PV.map((parentStep) => {
                                const parentStepNo = parentStep.step_id.split("-")[1];

                                return (
                                    <I2cAccordionStepItem
                                        key={parentStep.step_id}
                                        title={parentStep.title}
                                        description=""
                                        step-id={parentStep.step_id}
                                        auto-collapse
                                        status={checkParentStepValidation(
                                            singleFormValidStates,
                                            `${parentStepNo}_`,
                                            formValidatonConditions.find(cond => cond.prefix === `${parentStepNo}_`)?.count,
                                        ) && activeMainStep !== parentStepNo ? "complete" : activeMainStep === parentStepNo ? "inprogress" : "incomplete"}
                                    >
                                        {parentStep.innerSteps && parentStep.innerSteps.map((childStep) => (
                                            <I2cAccordionStepItem
                                                className={style.innerStep_dot}
                                                key={childStep.step_id}
                                                title={childStep.title}
                                                description=""
                                                step-id={childStep.step_id}
                                            />
                                        ))}
                                    </I2cAccordionStepItem>
                                );
                            })}
                            {/* {stepArray2PV.map((parentStep) => {
                const parentStepNo = parentStep.step_id.split("-")[1];

                return (
                  <I2cAccordionStepItem
                    key={parentStep.step_id}
                    title={parentStep.title}
                    description=""
                    step-id={parentStep.step_id}
                    auto-collapse
                    status={
                      checkParentStepValidation(
                        singleFormValidStates,
                        parentStepNo + "_",
                        formValidatonConditions.find(
                          (cond) => cond.prefix === parentStepNo + "_",
                        )?.count,
                      ) && activeMainStep != parentStepNo
                        ? "complete"
                        : activeMainStep == parentStepNo
                          ? "inprogress"
                          : "incomplete"
                    }
                  >
                    {parentStep.innerSteps &&
                      parentStep.innerSteps.map((childStep) => (
                        <I2cAccordionStepItem
                          className={style.innerStep_dot}
                          key={childStep.step_id}
                          title={childStep.title}
                          description=""
                          step-id={childStep.step_id}
                        />
                      ))}
                  </I2cAccordionStepItem>
                );
              })} */}
                        </I2cAccordionSteps>
                    </I2cCard>
                </div>
            </div>
        </I2cSidebar>
    );
    return (
        <>
            <div className="InstanceForms-wrapper">
                <div className="header-outer">
                    <SecureHeader />
                </div>
                <div id={"main"} className="demoContent">
                    {isMobileDevice ? (
                        <div className="sidebar_tablet_responsive">{sidebarComponent}</div>
                    ) : (
                        sidebarComponent
                    )}
                    <div part={"content"}>
                        <div className="contentContainer instance-container">
                            <div id="progress-steps-content" ref={progressStepsContent}>
                                {stepArray2PV.map((parent, parentIndex) => (
                                    <React.Fragment key={parent.step_id}>
                                        <div
                                            id={parent.step_id}
                                            className={activeStepper === parentIndex ? "active" : ""}>
                                            <div className={`${style.main_step_title + " title-subtitle-space"} ${(parent.title === "Geographical Region(s) Selection") && "minimumPadding"}`}>
                                                {parent.title}
                                            </div>
                                            {/* <I2cDivider style={{ "--borderWidth": "1px" }} /> */}
                                            {/* className="prepaidform_desc" */}
                                            <div>
                                                {" "}
                                                {isValidationError && (
                                                    <div className="alert-message-section-login">
                                                        <AlertMessage
                                                            open={isValidationError}
                                                            message={"Validation errors!"}
                                                        />
                                                    </div>
                                                )}{" "}
                                                {parent.description}{" "}
                                            </div>
                                        </div>
                                        {parent.innerSteps &&
                                            parent.innerSteps.map((child, childIndex) => (
                                                <div
                                                    key={child.step_id}
                                                    id={child.step_id}
                                                    className={
                                                        activeStepper === parentIndex && childIndex === 0
                                                            ? "active"
                                                            : ""
                                                    }
                                                >
                                                    <div
                                                        className={
                                                            style.main_step_title + " title-subtitle-space"
                                                        }
                                                    >
                                                        {parent.title}
                                                        {isValidationError && (
                                                            <div className="alert-message-section-login">
                                                                <AlertMessage
                                                                    open={isValidationError}
                                                                    message={"Validation errors!"}
                                                                />
                                                            </div>
                                                        )}{" "}
                                                    </div>

                                                    {
                                                        parent.title !== "Additional Authentication, Card Activation, and User Creation" && (
                                                            <div className="inner-step-title mb-24">
                                                                <span
                                                                    slot="label"
                                                                    className="organize-tooltip"
                                                                >
                                                                    {child.title}
                                                                    <I2cTooltip
                                                                        content={child.tooltip}
                                                                        placement="right-start"
                                                                    >
                                                                        <I2cIcon
                                                                            label="placement"
                                                                            name="cs-linear-info"
                                                                        ></I2cIcon>
                                                                    </I2cTooltip>
                                                                </span>
                                                            </div>
                                                        )
                                                    }
                                                    <div> {child.description} </div>
                                                </div>
                                            ))}
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className={style.cta_container}>
                        <div className={style.CtaContainer}>
                            {activeStep === "0_0" ? (
                                <span></span>
                            ) : (
                                <I2cButton
                                    variant="secondary gray"
                                    ref={previousBtn}
                                    onClick={handlePrevious}
                                >
                                    {isMobileDevice ? (
                                        <I2cIcon
                                            name="cs-linear-chevron-left"
                                            label="Previous"
                                        ></I2cIcon>
                                    ) : (
                                        "Previous"
                                    )}
                                </I2cButton>
                            )}
                            {/* disabled={!formValidStates[activeStep]} */}
                            <div layout="column" className={style.cta_btn_flex_inner}>
                                <I2cButton
                                    variant="secondary gray"
                                    ref={resetBtn}
                                    onClick={handleResetPopup}
                                >
                                    Cancel
                                </I2cButton>
                                <I2cButton
                                    disabled={
                                        !clientUser &&
                                            activeMainStep + "_" + activeInnerStep === "9_0" &&
                                            !isFormSubmittable
                                            ? true
                                            : activeStep === "9_0"
                                                ? false
                                                : !formValidStates[activeStep]
                                    }
                                    ref={nxtBtn}
                                    onClick={handleNext}
                                >
                                    {(clientUser &&
                                        activeMainStep + "_" + activeInnerStep === "9_1") ||
                                        (!clientUser &&
                                            activeMainStep + "_" + activeInnerStep === "9_0")
                                        ? "Submit"
                                        : "Save & Continue"}
                                </I2cButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {(isLoading || isFetching) && <OverlayLoader />}
            <style>{css}</style>
        </>
    );
};

export default PrepaidProduct;